import { useInstantSearch } from 'react-instantsearch';
import { useTopicsModalContext } from '../../Modals';
import { useTrackClickEvent } from '../../analytics';

export function TopicsButton(): React.ReactNode {
  const { openModal } = useTopicsModalContext();
  const { results } = useInstantSearch();

  const trackClick = useTrackClickEvent(
    results
      ? {
          index: results.index,
          nbHits: results.nbHits
        }
      : undefined
  );

  const handleClick = () => {
    openModal();
    trackClick({
      eventName: 'launch_topic_modal',
      additionalEvents: {
        event_interaction_context: 'topics_button'
      }
    });
  };

  return (
    <>
      <button
        type="button"
        className="peer inline w-full rounded-sm border-thin border-solid border-black/16 py-3 text-tui-sm text-textSecondary-onLight outline-none focus:border-blue-300"
        onClick={handleClick}
      >
        Topics
      </button>
    </>
  );
}
